<template>
  <div>
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <h1 class="display-4">¡Gracias por tu compra!</h1>
        <p class="lead">
          El siguiente paso para poder reservar el pedido es realizar una transferencia (mínimo el 50% de la compra). El plazo máximo para realizar este pago es el día y hora de cierre del pedido. Si este pago no está realizado al momento de cerrar el pedido, será anulado.
Una vez lleguen las cartas y esté confirmado el pago realizaremos el envío del producto a tu domicilio según la opción seleccionada.
        </p>
        <p class="lead">
          También puedes pagar con Webpay (tarjeta de débito o crédito) sin costo adicional para ti.
Sin embargo, es importante considerar que si realizas el pago con Webpay, cualquier devolución solo podrá hacerse como crédito en la tienda, ya que el sistema no permite reembolsos por transferencia.
Si deseas mantener la opción de devolución por transferencia, recomendamos realizar el pago mediante transferencia bancaria.
        </p>
        <p class="lead">
          <strong>Pago por </strong><a href="https://www.webpay.cl/form-pay/335926" target="_blank"><img src="../assets/images/Webpay_FB_300px.png" alt="Webpay" style="cursor: pointer; max-width: 120px; height: auto;"></a>
        </p>
        <p class="lead">
          La información de la cuenta para la transferencia es:
        </p>
        <ul class="list-group">
          <li class="list-group-item">Numero de Pedido: {{numeroPedido}}</li>
          <li class="list-group-item">Monto total de Compra: {{totalCompra}}</li>
          <li class="list-group-item">Nombre: {{cuentaBanco.nombre}}</li>
          <li class="list-group-item">Correo: {{cuentaBanco.correo}}</li>
          <li class="list-group-item">Banco: {{cuentaBanco.banco}}</li>
          <li class="list-group-item">Tipo: {{cuentaBanco.tipo}}</li>
          <li class="list-group-item">Número de Cuenta: {{cuentaBanco.numero}}</li>
          <li class="list-group-item">Rut: {{cuentaBanco.rut}}</li>
          <li class="list-group-item">Asunto: Indicar cual es el número de tu pedido</li>
        </ul>
        <br />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'PasoFinalCompra',
  data () {
    return {
      cuentaBanco: {}
    }
  },
  methods: {
    async getCuentaBanco () {
      const url = '/cuentaBanco'
      try {
        const resp = await axios.get(url, {
          baseURL: process.env.VUE_APP_URL_API_BESTTUTOR
        })
        this.cuentaBanco = await resp.data
      } catch (error) {
        this.$router.push({ name: 'Error' })
      }
    }
  },
  async beforeMount () {
    await this.getCuentaBanco()
    this.$store.state.modoCompra = true
  },
  beforeDestroy () {
    this.$store.state.modoCompra = false
  },
  computed: {
    ...mapState({
      numeroPedido: state => state.carro.numeroPedido,
      totalCompra: state => state.carro.totalCompra
    })
  }
}
</script>
